import React, { useEffect, useState } from "react";
import { AILogoIcon } from "../../../assets/images/svg";

const phrases = [
  "Searching for info…",
  "Gathering insights…",
  "Processing request…",
  "Analyzing data…",
  "Almost ready…"
];

const AILoader = ({ size = "small", textOnly }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (index >= phrases.length - 1) return;

    const interval = setInterval(() => {
      setIndex((prev) => prev + 1);
    }, 3000);

    return () => clearInterval(interval);
  }, [index]);

  if (textOnly) {
    return <span className="loading-text">{phrases[index]}</span>;
  }

  return (
    <div className={`ai_loader widget ai_loader--${size}`} data-testid="ai-loader">
      <AILogoIcon className="ai-logo-icon" />
      <span>{phrases[index]}</span>
    </div>
  );
};

export default AILoader;
